// Grids & Gantts — the two shapes a field value has.
//
// THE BUG THIS FILE EXISTS TO CLOSE. Pick a value in a cell; the write goes
// through, the work item's history shows the change — and the cell goes to a
// dash. Reload and the value is there. Nothing was lost; the page was
// showing the wrong shape.
//
// A Jira field is READ and WRITTEN in different shapes, and they are not
// interchangeable:
//
//   read   { id: '10203', value: 'High' }          a select
//          { accountId: 'abc', displayName: 'A' }  a user
//   write  { id: '10203' }                         a select
//          { accountId: 'abc' }                    a user
//
// The write shape is deliberately thin: the server is told WHICH value, and
// it looks the rest up. So a cell that patches its local copy with the write
// shape has a value with no `value` and no `displayName` in it — and every
// reader of that copy (`textsOf`, the tick in the picker, the Excel export)
// asks for exactly those and gets nothing. Hence the dash.
//
// So an edit produces BOTH: what the server is told, and what the page should
// now believe it holds. The display shape is not invented — it is the
// allowed value the reader picked, which arrived from `editmeta` already
// carrying its own label.
//
// Pure, and kept out of EditField.jsx so the suite can run it under node:
// a .jsx module cannot be imported without a browser, and this is the part
// that was wrong.

// What the server is told.
export function valueFor(def, picked) {
  const schema = (def && def.schema) || {};
  const isArray = schema.type === 'array';
  const one = (v) => {
    if (v == null) return null;
    if (v.accountId) return { accountId: v.accountId };
    if (v.id != null) return { id: String(v.id) };
    if (v.value != null) return { value: v.value };
    if (v.name != null) return { name: v.name };
    return String(v);
  };
  if (isArray) return (picked || []).map(one).filter(Boolean);
  return picked && picked.length ? one(picked[0]) : null;
}

// What the page should now believe it holds: the picked value ITSELF, with
// its label intact, in the cardinality the field has. A plain string (a free
// text field) is already its own display shape.
//
// `null` for a cleared single-value field and `[]` for a cleared multi are
// the same shapes a fresh read would return, so a cleared cell reads as
// empty rather than as unset-and-therefore-unknown.
export function displayFor(def, picked) {
  const schema = (def && def.schema) || {};
  if (schema.type === 'array') return (picked || []).filter((v) => v != null);
  return picked && picked.length && picked[0] != null ? picked[0] : null;
}

// Both halves of one edit, ready for `api.updateIssue` and for the page's own
// copy of the work item.
export const patchFor = (fieldId, def, picked) => ({
  write: { [fieldId]: valueFor(def, picked) },
  display: { [fieldId]: displayFor(def, picked) },
});
